export default __webpack_public_path__ + "static/logos-tiles-cvs-0bf7e0d5b7e6477914157d43244aec42.svg";